export enum DocumentType {
    Execution = 1,
    Development = 2,
    Technical = 3,
    Image = 4,
}
